<template>
	<div id="patient-sheet">
		<nav-bar name="Hoja de Paciente"></nav-bar>
		<div class="tabs is-boxed">
			<ul>
				<li
					:class="{ 'is-active': activeSheetView === SheetView.PatientInfo }"
					@click="activeSheetView = SheetView.PatientInfo"
				>
					<a>
						<span class="icon is-small"
							><i class="far fa-file-alt" aria-hidden="true"></i
						></span>
						<span>Información</span>
					</a>
				</li>
				<li
					:class="{
						'is-active': activeSheetView === SheetView.PatientMeasurements,
					}"
					@click="activeSheetView = SheetView.PatientMeasurements"
				>
					<a>
						<span class="icon is-small"
							><i class="far fa-file-alt" aria-hidden="true"></i
						></span>
						<span>Mediciones</span>
					</a>
				</li>
				<li
					:class="{ 'is-active': activeSheetView === SheetView.PatientNotes }"
					@click="activeSheetView = SheetView.PatientNotes"
				>
					<a>
						<span class="icon is-small"
							><i class="far fa-file-alt" aria-hidden="true"></i
						></span>
						<span>Notas</span>
					</a>
				</li>
				<li
					:class="{ 'is-active': activeSheetView === SheetView.PatientDiaries }"
					@click="activeSheetView = SheetView.PatientDiaries"
				>
					<a>
						<span class="icon is-small"
							><i class="far fa-file-alt" aria-hidden="true"></i
						></span>
						<span>Diario</span>
					</a>
				</li>
			</ul>
		</div>
		<div class="container">
			<template v-if="activeSheetView === SheetView.PatientInfo">
				<patient-info-sheet :patient="patient"></patient-info-sheet>
			</template>
			<template v-else-if="activeSheetView === SheetView.PatientMeasurements">
				<patient-measurements-sheet></patient-measurements-sheet>
			</template>
			<template v-else-if="activeSheetView === SheetView.PatientNotes">
				<patient-notes-sheet
					:doctorNotes="doctorNotes"
				></patient-notes-sheet>
			</template>
			<template v-else-if="activeSheetView === SheetView.PatientDiaries">
				<patient-diaries-sheet
					:createdAt="patient.createdAt.toDate()"
					:diaries="patient.diaries"
					:likertRecords="likertRecords"
				></patient-diaries-sheet>
			</template>
		</div>
	</div>
</template>

<script lang="ts">
	import useDoctor from "@/store/DoctorState";
	import usePatientHelper from "@/store/PatientHelperState";
	import { defineComponent, ref } from "vue";
	import { onBeforeRouteLeave } from "vue-router";
	import PatientInfoSheet from "@/components/PatientInfoSheet.vue";
	import PatientMeasurementsSheet from "@/components/PatientMeasurementsSheet.vue";
	import PatientNotesSheet from "@/components/PatientNotesSheet.vue";
	import PatientDiariesSheet from "@/components/PatientDiariesSheet.vue";
	import NavBar from "@/components/NavBar.vue";

	enum SheetView {
		PatientInfo,
		PatientMeasurements,
		PatientNotes,
		PatientDiaries,
	}
	export default defineComponent({
		name: "patient-card",
		components: {
			PatientInfoSheet,
			PatientMeasurementsSheet,
			PatientNotesSheet,
			PatientDiariesSheet,
			NavBar,
		},
		setup() {
			const { patientSelected, listenOnPatientDataChange } = useDoctor();
			const { fetchLikertRecords, likertRecords, fetchDoctorNotes, doctorNotes } = usePatientHelper();
			

			fetchDoctorNotes(patientSelected.value!.id)
			fetchLikertRecords(patientSelected.value!.id)
			let closeOnPatientDataChange = listenOnPatientDataChange(
				patientSelected.value!.id
			);
			onBeforeRouteLeave((_, __, next) => {
				closeOnPatientDataChange();
				next();
			});

			const activeSheetView = ref<SheetView>(SheetView.PatientInfo);

			return { patient: patientSelected, activeSheetView, SheetView, likertRecords, doctorNotes };
		},
	});
</script>